<span
  *ngIf="listStatus === listStatusConstants.archived"
  class="c-list-status-description"
  i18n="@@listStatusDescription-text-archived"
  >This is an archived list.</span
>
<span
  *ngIf="listStatus === listStatusConstants.draft"
  class="c-list-status-description"
  i18n="@@listStatusDescription-text-draft"
  >Students can’t see this draft.</span
>
<span
  *ngIf="listStatus === listStatusConstants.published"
  class="c-list-status-description"
  i18n="@@listStatusDescription-text-published"
  >This list is live, students can see latest changes.</span
>
<span
  *ngIf="listStatus === listStatusConstants.publishedWithUnpublishedChanges"
  class="c-list-status-description"
  i18n="@@listStatusDescription-text-publishedWithUnpublishedChanges"
  >Latest changes are not published.</span
>
